/* eslint-disable */
export default function () {
  return !!(typeof window !== 'undefined' && window.document && window.document.createElement);
}
